import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useState } from "react";
import { ProjectDocumentationList } from "../constants/ProjectDocumentationList";

const ProjectDocumentationListCard = () => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value: any) => setOpen(open === value ? 0 : value);

  const TABLE_HEAD = ["Document Name", "Date updated"];

  const Icon = ({ id, open }: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open
            ? "h-7 w-7 rotate-180 scale-100 rounded-full bg-[#482F8B33] p-1 text-[#482F8B]"
            : ""
        } h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  };

  return (
    <div className="max-w-full overflow-y-auto rounded-lg bg-white shadow-md">
      <h3 className="p-4 text-lg font-medium">Project Documentation List</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4">
        {ProjectDocumentationList.map((item, index) => {
          return (
            <Accordion
              key={index}
              placeholder={""}
              open={open === index}
              icon={<Icon id={index} open={open} />}
            >
              <AccordionHeader
                placeholder={""}
                onClick={() => handleOpen(index)}
                className="text-md font-primary font-medium"
              >
                {item.headline}
              </AccordionHeader>
              <AccordionBody className="font-primary">
                {/* <ul>
                  {item.documents.map((document, indexDoc) => {
                    return <li key={indexDoc}>{document.documentName}</li>;
                  })}
                </ul> */}
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {TABLE_HEAD.map((head, index) => (
                        <th
                          key={head}
                          className={`border-b border-blue-gray-100 bg-[#231F201A] p-4 ${
                            index === 0 ? "rounded-tl-lg" : "rounded-tr-lg"
                          }`}
                        >
                          <span className="font-primary font-medium text-gray-700">{head}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {item.documents.map((document, index) => {
                      const isLast = index === item.documents.length - 1;
                      const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                      return (
                        <tr key={document.documentName}>
                          <td className={classes}>
                            <span className="font-primary font-medium text-primaryPurple-100">
                              {document.documentName}
                            </span>
                          </td>
                          <td className={classes}>
                            <span className="font-primary font-medium text-gray-900">
                              {document.dateUpdated}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </AccordionBody>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectDocumentationListCard;
